import React from "react"
import styled from "styled-components"
import FillIcon from "./FillIcon"
import FeatureGridItem from "./FeatureGridItem"

import { SECONDARY_TEXT } from "./consts/colors"

const FeatureGridWrapper = styled.div`
  display: flex;
  margin-bottom: 100px;
  max-width: 1200px;
  width: 90%;
  border-radius: 18px;
  box-shadow: 0px 7px 15px ${SECONDARY_TEXT};
  background-color: white;

  @media (max-width: 980px) {
    margin-bottom: 150px;
  }
  @media (max-width: 768px) {
    margin-bottom: 100px;
  }
  @media (max-width: 615px) {
    width: 100%;
  }
`

const FeatureGrid = props => (
  <FeatureGridWrapper>
    <FeatureGridItem features={props.features} />
  </FeatureGridWrapper>
)

export default FeatureGrid



// WEBPACK FOOTER //
// ./src/components/FeatureGrid.js